import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ListAllEmployeesForVenue_1$Params } from 'src/api/generated/fn/employee/list-all-employees-for-venue-1';
import { GetGroups$Params } from 'src/api/generated/fn/group/get-groups';
import { EmployeeDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Employee/employee-dto';
import { GroupDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';
import { TableDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/table-dto';
import { EmployeeService, GroupService } from 'src/api/generated/services';
import { OrderSearchModel } from './order-search.model';
import { PrintTypeEnum } from 'src/app/pos-panel/enums/printer-type.enum';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';
import { UserDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/User/user-dto';
import { ListAllWaitersForVenue$Params } from 'src/api/generated/fn/employee/list-all-waiters-for-venue';

@Component({
  selector: 'app-orders-filter',
  templateUrl: './orders-filter.component.html',
  styleUrls: ['./orders-filter.component.scss']
})
export class OrdersFilterComponent implements OnInit {

  searchModel: OrderSearchModel;
  groups: Array<GroupDto>;
  tables: Array<any> = new Array<any>();
  waiters: Array<EmployeeDto>;
  venueId: string;
  PrintTypeEnum = PrintTypeEnum;
  printerTypes: Array<{key: string, value: any}> = [];
  date: Date;

  constructor(private ref: DynamicDialogRef,
              private config: DynamicDialogConfig,
              private groupService: GroupService,
              private authenticationService: AuthenticationService,
              private employeesService: EmployeeService) {   
      this.searchModel = new OrderSearchModel();
      Object.keys(PrintTypeEnum).slice((Object.keys(PrintTypeEnum).length/2)).forEach(key => this.printerTypes.push({key: key, value: PrintTypeEnum[key as any]}) )
      if(config.data != undefined){
        if(config.data.venueId != undefined){
          this.venueId = config.data.venueId;
          const groupParams: GetGroups$Params = { venueId: this.venueId, isRemoved: false };
            this.groupService.getGroups(groupParams).subscribe( response => {
              this.groups = response.groups ? response.groups : [];
              let tabs : Array<TableDto> = [];
              this.groups.forEach(group => group.servingAreaLayouts?.forEach(layout => tabs = tabs.concat(layout.tables ? layout.tables : [])));
              this.tables = [ ... new Set(tabs.map(t => t.name))].map(t => {return {name: t} as TableDto})
            });
            this.authenticationService.loginUser.subscribe(user => {
              if(user?.roles.includes(RoleNameEnum.PosManager)){
                const params: ListAllWaitersForVenue$Params = { VenueId: this.venueId }
                this.employeesService.listAllWaitersForVenue(params).subscribe( (response: any) => {
                  this.waiters = eval(response);
                });
              }else{
                const params: ListAllEmployeesForVenue_1$Params = { VenueId: this.venueId };
                this.employeesService.listAllEmployeesForVenue_1(params).subscribe( (response: any) => this.waiters = response ? response.filter((e: EmployeeDto) => e.venueEmployeeTypeId == 3) : []);
              }
          });
        }
        if(config.data.date != undefined){
          this.date = config.data.date;
        }
        if(config.data.model != undefined){
          if(config.data.model.orderNumbers){
            this.searchModel.orderNumbers = config.data.model.orderNumbers;
          }
          if(config.data.model.from){
            this.searchModel.from = config.data.model.from;
          }
          if(config.data.model.until){
            this.searchModel.until = config.data.model.until;
          }
          if(config.data.model.groups){
            this.searchModel.groups = config.data.model.groups;
          }
          if(config.data.model.tables){
            this.searchModel.tables = config.data.model.tables;
          }
          if(config.data.model.waiters){
            this.searchModel.waiters = config.data.model.waiters;
          }
          if(config.data.model.orderType != undefined){
            this.searchModel.orderType = config.data.model.orderType;
          }
        }
      }
  }

  ngOnInit(): void {
 
  }

  setDefaultFromDate(){
    if(this.searchModel.from == undefined){
      this.searchModel.from = new Date(this.date);
      this.searchModel.from.setHours(0, 0, 0, 0);
    }
  }

  setDefaultUntilDate(){
    if(this.searchModel.until == undefined){
      this.searchModel.until = new Date(this.date);
      this.searchModel.until.setHours(23, 59, 59, 59);
    }
  }

  clear(){
    this.searchModel = new OrderSearchModel();
  }

  filter(){
    if(this.searchModel.until && this.searchModel.from && this.searchModel.until < this.searchModel.from){
      this.searchModel.until.setDate(this.searchModel.until.getDate() + 1);
    }
    this.ref.close(this.searchModel);
  }

  cancel(){
    this.ref.close(null);
  }

}
